import { AxiosReportLas } from '../config';

interface GenerateExcelParams {
  empresa: number | string;
  dataInicial: string;
  dataFinal: string;
  unidades?: (number | string)[];
  grupoUnidades?: (number | string)[];
  subGrupoUnidades?: (number | string)[];
  gruposEquipamento?: (number | string)[];
  tiposEquipamento?: (number | string)[];
  equipamentos?: (number | string)[];
  sistemas?: (number | string)[];
}

const AvailabilityService = {
  generateExcel: ({
    empresa,
    dataInicial,
    dataFinal,
    unidades = [],
    grupoUnidades = [],
    subGrupoUnidades = [],
    gruposEquipamento = [],
    tiposEquipamento = [],
    equipamentos = [],
    sistemas = [],
  }: GenerateExcelParams) => {
    return AxiosReportLas({
      method: 'post',
      responseType: 'blob',
      headers: {
        'content-type': 'application/json',
      },
      url: `/v1/Relatorios/Disponibilidade`,
      data: {
        empresa,
        dataInicial,
        dataFinal,
        unidades,
        grupoUnidades,
        subGrupoUnidades,
        gruposEquipamento,
        tiposEquipamento,
        equipamentos,
        sistemas,
      },
    });
  },
};

export { AvailabilityService };
